module.exports = __webpack_public_path__ + "assets/images/card-pg-8_01966ff6c02ef6dadedab0ca80704cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-8.png
// module id = 195
// module chunks = 0